import React from "react";
import "./Choose.css";
import Icon1 from "../../images/smiley.png";
import Icon2 from "../../images/monitor.png";
import Icon3 from "../../images/client.png";
import Icon4 from "../../images/bar-chart.png";

const Choose = () => {
  return (
    <>
      <div className="choose-cnt">
        <div className="choose-heading-wrapper">
          <h1 className="choose-heading">Why choose us</h1>
        </div>
        <div className="choose-text-wrapper">
          <div className="choose-text">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et doloremagna aliqua. Ut enim
            ad minim veniam, quis
          </div>
        </div>
        <div className="choose-icon-cnt">
          <div className="choose-icon-wrapper">
            <div className="icon-cnt flex">
              <div className="icon">
                <img src={Icon1} alt="" />
              </div>
              <div className="icon-text">
                <h1 className="num">99%</h1>
                <div className="sub-text">SATISFIED CLIENTS</div>
              </div>
            </div>
          </div>
          <div className="choose-icon-wrapper">
            <div className="icon-cnt flex">
              <div className="icon">
                <img src={Icon2} alt="" />
              </div>
              <div className="icon-text">
                <h1 className="num">4700+</h1>
                <div className="sub-text">Awesome planing</div>
              </div>
            </div>
          </div>
          <div className="choose-icon-wrapper">
            <div className="icon-cnt flex">
              <div className="icon">
                <img src={Icon3} alt="" />
              </div>
              <div className="icon-text">
                <h1 className="num">4500+</h1>
                <div className="sub-text">Clients</div>
              </div>
            </div>
          </div>
          <div className="choose-icon-wrapper">
            <div className="icon-cnt flex">
              <div className="icon">
                <img src={Icon4} alt="" />
              </div>
              <div className="icon-text">
                <h1 className="num">19000+</h1>
                <div className="sub-text">Daily bussiness</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Choose;
